import { graphql } from 'gatsby';
import React, { useRef, useState } from 'react';
import Box from '../../components/Box/Box';
import Carousel from '../../components/Carousel/Carousel';
import WithSection from '../../components/WithSection/WithSection';
import {
    Caption,
    Headline,
    Subheading1,
} from '../../components/Typography/Typography';
import Image from '../../components/Image/Image';
import get from 'lodash/get';
import { theme } from '../../../config/theme';

export const SliderThemeMap = {
    default: {
        subtitle: 'primary.1000',
        border: '',
        arrowBgColor: 'primary.300',
        arrowColor: 'primary.main',
    },
    purple: {
        subtitle: 'tertiary.purple.1300',
        border: 'tertiary.purple.500',
        arrowBgColor: 'tertiary.purple.700',
        arrowColor: 'tertiary.purple.1700',
    },
};

const SliderSection = ({ data: { items }, styling: { sectionTheme } }) => {
    const [, setActiveSlide] = useState(0);
    const slider = useRef();
    const sliderTheme = SliderThemeMap[sectionTheme];

    return (
        <Box gridColumn={{ _: '1/-1', lg: '2/-2' }}>
            <Carousel
                ref={slider}
                dots
                arrows
                autoplay
                pauseOnHover
                pauseOnDotsHover
                pauseOnFocus
                smOptions={{ dots: false }}
                mdOptions={{ dots: false }}
                sliderTheme={sliderTheme}
                beforeChange={(_, index) => setActiveSlide(index)}
            >
                {items.map(({ title, subtitle, description, image }, i) => (
                    <Box key={i}>
                        <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            paddingBottom="40px"
                        >
                            <Box
                                borderRadius="4px"
                                width={{ _: '96%', md: '80%' }}
                                overflow="hidden"
                                padding="40px"
                                bg="neutral.white"
                                border={`2px solid ${get(
                                    theme.colors,
                                    sliderTheme.border
                                )}`}
                            >
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    gap="24px"
                                >
                                    <Box
                                        display="flex"
                                        gap="17px"
                                        alignItems="center"
                                    >
                                        <Image img={image} />
                                        <Box
                                            display="flex"
                                            flexDirection="column"
                                        >
                                            <Headline bold mb="2px">
                                                {title.text}
                                            </Headline>
                                            <Caption
                                                color={sliderTheme.subtitle}
                                            >
                                                {subtitle}
                                            </Caption>
                                        </Box>
                                    </Box>
                                    <Subheading1>
                                        <Box
                                            as="span"
                                            color={sliderTheme.subtitle}
                                            fontWeight="bold"
                                        >
                                            "{' '}
                                        </Box>
                                        {description}
                                        <Box
                                            as="span"
                                            color={sliderTheme.subtitle}
                                            fontWeight="bold"
                                        >
                                            {' '}
                                            "
                                        </Box>
                                    </Subheading1>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Carousel>
        </Box>
    );
};

// TODO: convert to fragments
export const _ = graphql`
    fragment SLIDER_SECTION on PrismicSectionDataBodySliderSection {
        items {
            title {
                text
            }
            subtitle
            description
            image {
                gatsbyImageData(layout: CONSTRAINED, height: 63)
                alt
                url
            }
        }
    }
`;

export default WithSection(SliderSection);
